import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faWifi, faMobileAlt, faSpinner, faCheckCircle, faEdit,
  faCrown, faUser, faMinusCircle, faBan, faCopy } from '@fortawesome/free-solid-svg-icons';
import { SoundService } from './sound.service';

library.add(faWifi,
  faMobileAlt,
  faSpinner,
  faCheckCircle,
  faCrown,
  faUser,
  faMinusCircle,
  faBan,
  faCopy,
  faEdit);

@NgModule({
  declarations: [
    AppComponent,
    PageNotFoundComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FontAwesomeModule,
  ],
  exports: [
    FontAwesomeModule,
  ],
  providers: [
    SoundService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
